import angular from 'angular';
import * as R from 'ramda';

export default function EditProcessDialogController(
  $scope,
  $rootScope,
  $filter,
  $timeout,
  ssDialogService,
  alerts,
  loaderService,
  emDataService,
  emSharedModelService,
  editFunctionDialog
) {
  const vm = this;

  vm.process.newName = vm.process.name;
  vm.processId = vm.process.processId;
  vm.handleCloseDialog = handleCloseDialog;
  vm.handleAddFunction = handleAddFunction;
  vm.handleDeletedFunction = _handleDeletedFunction;
  vm.handleSubmit = handleSubmit;
  vm.handleDepartmentChange = handleDepartmentChange;

  _activate();

  _initEventListeners();

  /** ***************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSubmit() {
    loaderService.showViewLoader = true;
    // Check form validity
    if (!$scope.emEditProcessForm.$valid) {
      loaderService.showViewLoader = false;
      $scope.emEditProcessForm.$submitted = false;
      return false;
    }

    if (!checkSuccessionPlanning()) {
      loaderService.showViewLoader = false;
      $scope.emEditProcessForm.$submitted = false;
      return false;
    }

    return _saveProcess().then(() => {
      _broadcastChanges();
      loaderService.showViewLoader = false;
      $scope.emEditProcessForm.$submitted = false;

      switch (vm.saveType) {
        case 'saveAndAddAnother':
          alerts.success('The process has been saved successfully.');
          _resetViewModel();
          break;
        case 'saveAndClose':
          alerts.success('The process has been saved successfully.');
          _closeDialog();
          break;
        case 'save':
          alerts.success('The process has been saved successfully.');
          break;
        default:
          break;
      }
    });
  }

  function handleAddFunction($event) {
    $scope.emEditProcessForm.$submitted = true;
    loaderService.showViewLoader = true;

    if (!$scope.emEditProcessForm.$valid) {
      loaderService.showViewLoader = false;
      return false;
    }

    if (!checkSuccessionPlanning()) {
      loaderService.showViewLoader = false;
      return false;
    }

    return _saveProcess()
      .then(() => {
        alerts.success('The process has been saved.');
        _broadcastChanges();
        return _getDefaultFunction()
          .then((defaultFunction) => {
            defaultFunction.functionId = -1;
            defaultFunction.processId = vm.processId;
            defaultFunction.canDeleteFunction = true;
            loaderService.showViewLoader = false;
            return _showEditFunctionDialog($event, defaultFunction);
          });
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleDeletedFunction(functionObj) {
    if (!functionObj) return;
    const pos = vm.process.functions.indexOf(functionObj);
    if (pos === -1) return; // Can't find the item
    vm.process.functions.splice(pos, 1);
  }

  function handleDepartmentChange(){
    const filteredDepartments = R.filter(R.propEq('departmentId', vm.selectedDepartmentId), emDataService.departments);
    if(filteredDepartments && filteredDepartments.length > 0){
      vm.department = {...filteredDepartments[0]}
      vm.process.departmentId = vm.selectedDepartmentId
    }    
  }

  /** ***************************************
   * Private functions
   */

  function _showEditFunctionDialog($event, functionObj) {
    ssDialogService.dialogs.enterpriseModeling.editFunctionDialog = ssDialogService.alert(
      editFunctionDialog.getOptions($event, {
        customerId: vm.customerId,
        department: vm.department,
        process: vm.process,
        functionObj,
        addCallback: _handleAddedFunction,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editFunctionDialog);
  }

  function _handleAddedFunction(functionObj) {
    vm.process.functions = vm.process.functions || [];
    vm.process.functions.push(functionObj);
    if (vm.process.functions.length > 1) {
      vm.process.functions = emSharedModelService.sortByName(vm.process.functions);
    }
    _broadcastChanges();
  }

  function _getDefaultFunction() {
    return emDataService.getFunction(0)
      .then(response => response.data);
  }

  function _resetViewModel() {
    vm.process.newName = '';
    vm.process.name = '';
    vm.process.processId = 0;
    // vm.process.masterProcessId = 0;
    vm.process.functions = [];
    vm.process.canEditProcess = true;

    vm.process.successions = {
      primary: null,
      alternate: null,
      tertiary: null,
    };

    $scope.emEditProcessForm.$setPristine();
    $scope.emEditProcessForm.$setUntouched();

    emDataService.getSuccessorOptions(vm.process.processId).then((response) => {
      vm.successorOptions = response;
    });
  }

  function _broadcastChanges() {
    _refreshDepartmentFromAPI()
      .then(() => {
        if(vm.originalDepartmentId === vm.selectedDepartmentId){
          $rootScope.$broadcast('moveDepartmentRefresh', { departmentId: vm.selectedDepartmentId, processId: vm.process.processId });
        } else {
          $rootScope.$broadcast('collapseProcess', { processId: vm.process.processId });
          $rootScope.$broadcast('moveDepartmentRefresh', { departmentId: vm.selectedDepartmentId, processId: vm.process.processId });
        }       
      });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.editProcessDialog);
  }

  function _saveProcess() {
    return emDataService.saveProcess(vm.department.departmentId, vm.process.processId,
      vm.process.newName, vm.process.successions)
      .then((saveProcessResponse) => {
        vm.processId = saveProcessResponse.data;

        _updateViewModelFromUserInput(vm.processId);
      });
  }

  function _refreshDepartmentFromAPI() {
    return emDataService.getDepartment(vm.department.departmentId, vm.customerId)
      .then((getDepartmentResponse) => {
        angular.extend(vm.department, getDepartmentResponse.data.result);
      });
  }

  function _updateViewModelFromUserInput(processId) {
    vm.process.processId = processId;
    vm.process.name = vm.process.newName;
    if(vm.originalDepartmentId === vm.selectedDepartmentId){
       const existingProcess = $filter('filter')(vm.department.processes, {
        processId: vm.process.processId
      }, true);

      if (existingProcess.length) {
        vm.department.processes[vm.department.processes.indexOf(existingProcess[0])] = vm.process;
      } else {
        vm.department.processes.push(vm.process);
      }
    } else {
      const existingProcess = $filter('filter')(vm.originalDepartment.processes, {
        processId: vm.process.processId
      }, true);

      if (existingProcess && existingProcess.length>0) {
        vm.department.processes.push(vm.process);
        const indexP = vm.originalDepartment.processes.findIndex(p => p.processId === vm.process.processId);
        vm.originalDepartment.processes.splice(indexP, 1);
      } else {
        vm.department.processes.push(vm.process);
      }
    }
   
  }

  function checkSuccessionPlanning() {
    if (vm.process.successions.primary) {
      vm.process.successions.primary.planPriority = 1;
    }
    if (vm.process.successions.alternate) {
      vm.process.successions.alternate.planPriority = 2;
    }
    if (vm.process.successions.tertiary) {
      vm.process.successions.tertiary.planPriority = 3;
    }

    // Make sure there is a primary if a secondary is filled out
    if ((vm.process.successions.alternate !== null) && (vm.process.successions.primary === null)) {
      alerts.error('There must be a Primary Resource for an Alternate Resource to be set.');
      return false;
    }

    // Make sure there is a primary and secondary if a tertiary is filled out
    if ((vm.process.successions.tertiary !== null) && ((vm.process.successions.alternate === null)
      || (vm.process.successions.primary === null))) {
      alerts.error('There must be a Primary Resource and Alternate Resource for a Tertiary Resource to be set.');
      return false;
    }

    return true;
  }

  function _activate() {
    vm.process.successions = {};
    assignSuccessionPlan();
    vm.departments = emDataService.departments;
    vm.selectedDepartmentId = vm.department.departmentId;
    vm.originalDepartmentId = vm.department.departmentId;
    vm.originalDepartment = {...vm.department}
  }
  
  function _initEventListeners() {
    $scope.$on('departmentsRefreshed', (event, opt) => {
      vm.departments = emDataService.departments;
    });
  }

  function assignSuccessionPlan() {
    if (vm.process.successionPlans && vm.process.successionPlans.length > 0) {
      vm.process.successionPlans.forEach((u) => {
        if (u.userId) {
          u.name = u.userName;
        } else if (u.vendorId) {
          u.name = u.vendorName;
          u.isVendor = true;
        }
        switch (u.planPriority) {
          case 1:
            vm.process.successions.primary = u;
            break;
          case 2:
            vm.process.successions.alternate = u;
            break;
          case 3:
            vm.process.successions.tertiary = u;
            break;
          default:
            return false;
        }
      });
    }
  }
}

EditProcessDialogController.$inject = [
  '$scope',
  '$rootScope',
  '$filter',
  '$timeout',
  'ssDialogService',
  'alerts',
  'loaderService',
  'emDataService',
  'emSharedModelService',
  'editFunctionDialog',
];
